import styled from 'styled-components';

export const Overlay = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.72);
  z-index: 4500;
  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
`;

export const Box = styled.div`
  background: #0f1f1a;
  border: 1px solid #1e3028;
  border-radius: 16px;
  padding: 30px 32px 24px;
  width: 640px;
  max-width: 94vw;
  max-height: 94vh;
  display: flex;
  flex-direction: column;
  gap: 18px;
  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.6);
`;

export const Title = styled.div`
  font-family: var(--head);
  font-weight: 700;
  font-size: 22px;
  color: #f0e8d8;
  letter-spacing: 0.2px;
`;

export const FormBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-right: 6px;

  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.18);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.24);
    border-radius: 6px;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldRow = styled.div`
  display: flex;
  gap: 18px;

  ${FieldGroup} {
    flex: 1;
    min-width: 0;
  }
`;

export const FieldLabel = styled.label`
  font-family: var(--body);
  font-size: 12px;
  font-weight: 700;
  color: #8aa090;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

const fieldSurface = `
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: #f0e8d8;
  font-family: var(--body);
  font-size: 13px;
  padding: 8px 10px;
  transition:
    border-color 0.15s,
    background 0.15s;

  &::placeholder {
    color: rgba(255, 255, 255, 0.28);
  }

  &:focus {
    outline: none;
    border-color: #ff7a10;
    background: rgba(255, 255, 255, 0.09);
  }
`;

export const TextInput = styled.input<{ $error?: boolean }>`
  ${fieldSurface}
  ${({ $error }) => $error && `border-color: #c97f9d;`}
`;

export const DateInput = styled.input`
  ${fieldSurface}
  color-scheme: dark;
`;

export const SelectField = styled.select<{ $error?: boolean }>`
  ${fieldSurface}
  ${({ $error }) => $error && `border-color: #c97f9d;`}
  appearance: none;

  option {
    background: #16201c;
    color: #f0e8d8;
  }
`;

export const ErrorHint = styled.span`
  font-size: 11px;
  color: #e0879f;
  font-family: var(--body);
`;

export const SegmentGroup = styled.div`
  display: flex;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 9px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.04);
`;

export const SegmentOption = styled.button<{ $active: boolean }>`
  flex: 1;
  padding: 6px 8px;
  background: ${({ $active }) => ($active ? '#ff7a10' : 'transparent')};
  color: ${({ $active }) => ($active ? '#fff' : '#c8d8b8')};
  border: none;
  cursor: pointer;
  font-family: var(--body);
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  transition: background 0.15s;

  &:not(:last-child) {
    border-right: 1px solid rgba(255, 255, 255, 0.1);
  }

  &:hover {
    background: ${({ $active }) =>
      $active ? '#ff7a10' : 'rgba(255, 255, 255, 0.08)'};
  }

  &:focus {
    outline: none;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-shrink: 0;
`;

export const SaveBtn = styled.button`
  background: #ff7a10;
  border: none;
  color: #fff;
  border-radius: 8px;
  padding: 10px 22px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  font-family: var(--body);
  transition: background 0.15s;

  &:hover {
    background: #ff8c2e;
  }
`;

export const CancelBtn = styled.button`
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #c8d8b8;
  border-radius: 8px;
  padding: 10px 18px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  font-family: var(--body);
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.13);
  }
`;
